import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  selector: 'app-our-values',
  imports: [
    NgOptimizedImage,
    NgxTolgeeModule,
  ],
  templateUrl: './our-values.component.html'
})
export class OurValuesComponent {
  values = [ 1, 2, 3, 4, 5 ];
}
